import { render, staticRenderFns } from "./RateCardCreateConnectChannels.vue?vue&type=template&id=0c3d556d&scoped=true&"
import script from "./RateCardCreateConnectChannels.vue?vue&type=script&lang=ts&"
export * from "./RateCardCreateConnectChannels.vue?vue&type=script&lang=ts&"
import style0 from "./RateCardCreateConnectChannels.vue?vue&type=style&index=0&id=0c3d556d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d556d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VDataTable,VForm,VRow,VSpacer})
